import { render, staticRenderFns } from "./regionalTimeliness.vue?vue&type=template&id=36efe41a&scoped=true"
import script from "./regionalTimeliness.vue?vue&type=script&lang=js"
export * from "./regionalTimeliness.vue?vue&type=script&lang=js"
import style0 from "./regionalTimeliness.vue?vue&type=style&index=0&id=36efe41a&lang=css"
import style1 from "./regionalTimeliness.vue?vue&type=style&index=1&id=36efe41a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36efe41a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36efe41a')) {
      api.createRecord('36efe41a', component.options)
    } else {
      api.reload('36efe41a', component.options)
    }
    module.hot.accept("./regionalTimeliness.vue?vue&type=template&id=36efe41a&scoped=true", function () {
      api.rerender('36efe41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/SHEINDailyDeliveryData/components/regionalTimeliness.vue"
export default component.exports